import safetyCap from '../../images/safety-cap.svg';
import safetyBelt from '../../images/safety-belt.svg';
import safetyShoes from '../../images/safety-shoes.svg';
import worker from '../../images/character-worker.svg';
import { AiFillCamera } from 'react-icons/ai';
import { useRef } from 'react';

export default function TmTBMChkList({ agrd, setAgrd, fileRef, setCamOpen, fileSrc, doneTBM }: any) {

  const inputRef = useRef<any>();
  const inputClick = () => { inputRef.current.click(); };

  return (
    <div className='flex flex-col justify-center items-center w-[260px] sm:w-[318px] md:w-[750px]'>
      <div className='my-22 md:my-[55px] py-14 md:py-[35px] w-full bg-[#FFEEEF] rounded-[5px] md:rounded-[12px] text-14 leading-17 md:text-32 md:leading-[42px]'>
        <p className='ml-10 md:ml-[25px]'>※ 작업에 필요한 보호구를 확인하고 모두 착용해 주세요.</p>
      </div>
      <div className='flex w-full relative'>
        <img src={worker} alt='worker' className='w-120 md:w-[300px] h-[285px] md:h-[712px] absolute z-10 top-45 md:top-[112px]' />
        <div className='flex flex-col w-full items-end z-20'>
          <div className='flex items-center'>
            <div className='w-7 h-7 md:w-[17px] md:h-[17px] rounded-full bg-point' /><div className='w-61 md:w-[180px] border border-x-0 border-t-0 border-point' />
            <div className='w-[206px] h-103 md:w-[450px] md:h-[257px] rounded-[5px] md:rounded-[12px] bg-[#F5F6F8] border border-[#C9C9C9] flex justify-evenly items-center mb-19 md:mb-[47px] relative'>
              <img src={safetyCap} alt='cap' className='w-68 h-77 md:w-[150px] md:h-[180px]' /><p className='text-14 leading-17 md:text-35 md:leading-42 font-preBold'>안전모</p>
            </div>
          </div>
          <div className='flex items-center'>
            <div className='w-7 h-7 md:w-[17px] md:h-[17px] rounded-full bg-point' /><div className='w-61 md:w-[180px] border border-x-0 border-t-0 border-point' />
            <div className='w-[206px] h-103 md:w-[450px] md:h-[257px] rounded-[5px] md:rounded-[12px] bg-[#F5F6F8] border border-[#C9C9C9] flex justify-evenly items-center mb-19 md:mb-[47px] relative'>
              <img src={safetyBelt} alt='belt' className='w-86 h-73 md:w-[160px] md:h-[180px]' /><p className='text-14 leading-17 md:text-35 md:leading-42 font-preBold'>안전대/벨트</p>
            </div>
          </div>
          <div className='flex items-center'>
            <div className='w-7 h-7 md:w-[17px] md:h-[17px] rounded-full bg-point' /><div className='w-61 md:w-[180px] border border-x-0 border-t-0 border-point' />
            <div className='w-[206px] h-103 md:w-[450px] md:h-[257px] rounded-[5px] md:rounded-[12px] bg-[#F5F6F8] border border-[#C9C9C9] flex justify-evenly items-center md:mb-[47px] relative'>
              <img src={safetyShoes} alt='shoes' className='w-85 h-52 md:w-[160px] md:h-[180px]' /><p className='text-14 leading-17 md:text-35 md:leading-42 font-preBold'>안전화</p>
            </div>
          </div>
        </div>
      </div>
      {!doneTBM && fileSrc === ''
        ? <div
          onClick={() => setCamOpen(true)}
          className='flex justify-center items-center border border-[#C9C9C9] rounded-[5px] md:rounded-[12px] w-full h-43 md:h-[107px] text-[#A0A0A0] text-14 mt-18 md:text-35 md:mt-[45px]'>
          <AiFillCamera className='text-20 mr-9 md:text-50 md:mr-[22px]' /><p>사진 첨부</p>
        </div>
        : <div className='flex flex-col items-center mt-20 md:mt-[50px] border border-b-0 border-x-0 border-[#C9C9C9]'>
          <div className='flex relative mt-12 mb-7 md:mt-[30px] md:mb-[17px]'>
            <p className='my-5 text-15 md:my-[12px] md:text-37 font-preBold'>{!doneTBM ? '미리보기' : '사진 확인'}</p>
            {!doneTBM && <button
              onClick={() => setCamOpen(true)}
              className='absolute translate-x-[200%] md:translate-x-[190%] mr-7 md:mr-[18px] w-60 md:w-[150px] h-32 md:h-[80px] text-white text-14 leading-16 md:text-35 md:leading-[40px] rounded-[5px] md:rounded-[12px] bg-[#585959]'>다시 촬영</button> }
          </div>
          {/* <p>file src = {fileSrc}</p> */}
          {!doneTBM ? <img alt='img' src={fileSrc} className='border border-[#C9C9C9] rounded-[10px] md:rounded-[25px] object-cover' />
                    : <img alt='doneImg' src={'admin/api/cmmn/fileDownload?atchFileId=' + fileSrc + '&fileSn=0'} className='border border-[#C9C9C9] rounded-[10px] md:rounded-[25px] object-cover' />}
        </div>}
      <input hidden type='file' ref={fileRef} />
      {/*<div className='flex w-full mt-18 md:mt-[45px]'>*/}
      {/*  {!agrd[2] ? <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 2: !agrd[2] }))} type='checkbox' className='accent-point md:w-[40px]' />*/}
      {/*    : <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 2: !agrd[2] }))} type='checkbox' className='accent-point md:w-[40px]' defaultChecked />}*/}
      {/*  <p onClick={inputClick} className='ml-10 md:ml-[25px] text-[#9C9C9B] text-13 leading-15 md:text-30 md:leading-[37px] font-preLight underline underline-offset-1 decoration-[#9C9C9B] decoration-[0.5px]'>*/}
      {/*    작업자 전원의 보호장비 착용을 확인했습니다.*/}
      {/*  </p>*/}
      {/*</div>*/}
    </div>
  );
}

